import React from 'react';
import { Link } from 'react-router-dom';
import { brands } from '../../data/navigation';
export function BrandStrip() {
  return <section aria-labelledby="brands-heading" className="border-y border-line" data-id="element-114" data-mp="3dsnr4prr2lm4">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-8 sm:px-6 lg:flex-row lg:items-center lg:gap-10 lg:px-8" data-id="element-115" data-mp="3iq62snx5jext">
        <h2 id="brands-heading" className="shrink-0 text-sm font-medium text-muted" data-id="element-116" data-mp="3nj8ne6jybe1v">
          Official dealer of
        </h2>
        <ul className="flex flex-wrap items-center gap-x-8 gap-y-3 lg:flex-1 lg:justify-between" data-id="element-117" data-mp="1apjpjycurm4">
          {brands.map(b => <li key={b} data-id="element-118" data-mp="5c2so2wqvax9">
              <Link to="/shop" className="text-lg font-bold tracking-tight text-ink/45 transition-colors duration-150 hover:text-ink" data-id="element-119" data-mp="5cubse95ng6n">
                {b}
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}